import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { PerfilService } from '../../pages/administracao/perfil/perfil.service';
import { ToastService } from '../../services/toast.service';
import { Perfil } from '../../types/Perfil.type';

@Component({
  selector: 'app-perfil-dialog',
  templateUrl: './perfil-dialog.component.html',
  styleUrl: './perfil-dialog.component.css'
})
export class PerfilDialogComponent {

  @Input() visivel: boolean = false;
  @Input() cliente: string = "";
  @Input() perfilParam!: Perfil;
  @Output() public fechar = new EventEmitter();

  perfil: Perfil = {} as Perfil;
  perfilEnviado: boolean = false;

  permissoes: TreeNode[] = [];
  permissoesSelecionadas: TreeNode[] = [];

  constructor(private perfilService: PerfilService, private toastService: ToastService){}

  ngOnInit(){

    // if(this.perfilParam) this.perfil = this.perfilParam;

    // this.perfilService.getPermissoes().subscribe((value) => {
    //   value.forEach((value, index) => {
    //     var moduloNode: TreeNode = {};

    //     moduloNode.key = value.id
    //     moduloNode.label = value.modulo

    //     var submodulosNode: TreeNode[] = []
    //     value.submodulos.forEach((value, index) => {
    //       var submoduloNode: TreeNode = {}

    //       submoduloNode.key = value.id
    //       submoduloNode.label = value.nome

    //       submodulosNode.push(submoduloNode);
    //     })

    //     moduloNode.children = submodulosNode;

    //     this.permissoes.push(moduloNode)

    //   })
    // })
  }


  escondeDialog() {
    this.visivel = false;
    this.perfilEnviado = false;
    this.perfil = {} as Perfil;

    this.fechar.emit();
  }


  salvar(){
    // this.perfilEnviado = true;

    // this.perfil.submodulos = []

    // this.permissoesSelecionadas.forEach((value) => {
    //   var sub: Submodulo = {} as Submodulo
    //   sub.id = value.key || ''

    //   if(sub.id?.trim())
    //     this.perfil.submodulos.push(sub);
    // })
    
    // if(this.perfil.nomePerfil?.trim()){
    //   this.perfilService.post(this.perfil).subscribe({
    //     next: () => {
    //       this.toastService.sucesso("Sucesso", "Perfil Salvo com sucesso");
    //       // this.escondeDialog();
    //     },
    //     error: (error) => {
    //       this.toastService.erro("Erro", "Erro ao salvar o perfil: " + error.error);
    //     }
    //   })
    // }
    
  }

}
